import { useState } from "react";
import { useWorkspace } from "@/contexts/WorkspaceContext";
import { KnowledgeBaseDetail } from "@/components/KnowledgeBase/KnowledgeBaseDetail";
import { KnowledgeBaseList } from "@/components/KnowledgeBase/KnowledgeBaseList";

/**
 * The knowledge bases of the current workspace, and one of them opened: its
 * files, its upload and its description. Everything goes through the
 * `knowledge-base` edge function (design §4-5).
 */
export default function KnowledgeBase() {
  const { currentWorkspaceId } = useWorkspace();
  const [openId, setOpenId] = useState<string | null>(null);

  if (!currentWorkspaceId) {
    return <p className="p-8 py-12 text-center text-muted-foreground">Loading workspace...</p>;
  }
  return openId ? (
    <KnowledgeBaseDetail key={openId} workspaceId={currentWorkspaceId} id={openId} onBack={() => setOpenId(null)} />
  ) : (
    <KnowledgeBaseList workspaceId={currentWorkspaceId} onOpen={setOpenId} />
  );
}
